import React from 'react'
import PropTypes from 'prop-types'

import { Text, BadgeButton } from '@offerzen/pinata'
import PencilIcon from '@offerzen/zenicon/PencilIcon'
import TrashIcon from '@offerzen/zenicon/TrashIcon'
import styles from './styles'

const RolePreview = ({ id, ...props }) => (
  <div className={styles.wrapper} data-test="preferred-role-preview">
    <Text className={styles.roleData}>
      <p id={id} aria-hidden>
        {props.name}
      </p>
      <p aria-labelledby={id}>{props.yearsExperience} years</p>
    </Text>

    <BadgeButton icon={TrashIcon} onClick={props.deleteJobExperience} className={styles.deleteButton} />
    <BadgeButton icon={PencilIcon} onClick={props.toggleJobExperienceEdit} />
  </div>
)

RolePreview.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  yearsExperience: PropTypes.string,
  deleteJobExperience: PropTypes.func,
  toggleJobExperienceEdit: PropTypes.func,
}

export default RolePreview
